import { type FetchResult, type TypedDocumentNode, useMutation } from '@apollo/client';
import { enqueueSnackbar } from 'notistack';
import { useCallback } from 'react';
import { GET_WAREHOUSE_LOCATIONS, UPDATE_WAREHOUSE_LOCATION_MUTATION } from 'src/api/warehouses.api';
import { notifyUnlessSurfaced } from 'src/lib/apollo/appErrorLink';
import type { UpdateWarehouseLocation, UpdateWarehouseLocationVariables } from 'types/graphql';

const UPDATE_WAREHOUSE_LOCATION: TypedDocumentNode<UpdateWarehouseLocation, UpdateWarehouseLocationVariables> =
  UPDATE_WAREHOUSE_LOCATION_MUTATION;

export function useUpdateWarehouseLocation() {
  const [mutate, { loading, error }] = useMutation(UPDATE_WAREHOUSE_LOCATION, {
    refetchQueries: [GET_WAREHOUSE_LOCATIONS],
    onCompleted: () => {
      enqueueSnackbar('Location updated successfully');
    },
    onError: (mutationError) => {
      notifyUnlessSurfaced(mutationError, 'Failed to update location.');
    },
  });
  const update = useCallback(
    ({ id, input }: UpdateWarehouseLocationVariables): Promise<FetchResult<UpdateWarehouseLocation>> =>
      mutate({ variables: { id, input } }),
    [mutate]
  );

  return { update, loading, error };
}
